<template>
    <div class="swiper-partners-wrapper">
        <h6 class="text-center mb-4">{{ $t('Nos partenaires') }}</h6>
        <div :class="'swiper-partners-' + swiperId" class="swiper-partners">
            <div class="swiper-wrapper">
                <div
                    v-for="(slide, index) in orderedPartners"
                    :key="'swiper-partners-slide-' + index"
                    class="swiper-slide"
                >
                    <AssetLoader
                        v-if="slide.logoId"
                        :asset="{ asset: slide.logoId }"
                        class="partner-logo"
                    />
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle.js'

// import styles bundle
import 'swiper/swiper-bundle.min.css'

export default {
    name: 'SwiperPartners',
    components: {
        AssetLoader,
    },
    props: {
        imgGallery: {
            type: Array,
            required: true,
        },
        swiperId: {
            type: String,
            required: true,
        },
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    setTimeout(() => {
                        new Swiper('.swiper-partners-' + this.swiperId, {
                            // Optional parameters
                            loop: false,
                            grabCursor: true,
                            centeredSlides: true,
                            autoplay: {
                                delay: 2500,
                                disableOnInteraction: true,
                              },
                            // If we need pagination
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                            },
                        })
                    }, 2000)
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
        orderedPartners() {
            if(!this.imgGallery) {
                return []
            }
            const genericList = [...this.imgGallery]
            return genericList.sort((a, b) => {
                return a.order - b.order
            })
        },
    },
}
</script>
